"use client";
import "./funds_exposure.scss";
import { useFunds } from "@/contexts/funds-context";
import { Container } from "@/elements/container/container";
import { Dropdown } from "@/elements/dropdown/dropdown";
import { Stack } from "@/elements/stack/stack";
import { Text } from "@/elements/text/text";
import { i18n } from "@/model/i18n";
import { AssetsDonut } from "@/components/assets_donut/assets_donut";
import { WorldMap } from "@/components/world_map/world_map";
import { useState, type ReactElement } from "react";

const OPTIONS = [
  {
    label: i18n.t("pages.funds.exposure.regions"),
    value: "regions",
  },
  {
    label: i18n.t("pages.funds.exposure.asset_classes"),
    value: "asset-classes",
  },
];

export function FundsExposure(): ReactElement | null {
  const { selectedFund } = useFunds();
  const [selectedChart, setSelectedChart] =
    useState<(typeof OPTIONS)[number]["value"]>("regions");

  return (
    <section className="funds-exposure" aria-label="funds-exposure">
      <Container>
        <Stack size={40} tabletSize={80}>
          <Stack
            size={24}
            line="desktop"
            justifyDesktop="space-between"
            alignDesktop="center"
          >
            <Text type="h2-xbold" color="primary-on-default" htmlElement="h2">
              {i18n.t("pages.funds.exposure.exposure_breakdown")}
            </Text>
            <div>
              <Dropdown
                id="funds-exposure-dropdown"
                options={OPTIONS}
                value={selectedChart}
                onChange={(option) => setSelectedChart(option)}
              />
            </div>
          </Stack>
          {selectedChart === "regions" && (
            <WorldMap regions={selectedFund?.assetRegions || []} />
          )}
          {selectedChart === "asset-classes" && (
            <AssetsDonut
              assetSubclasses={selectedFund?.assetSubclasses || []}
            />
          )}
        </Stack>
      </Container>
    </section>
  );
}
